/**
 * The two Bandsintown URLs the app itself needs. Everything else about the
 * widget lives in `src/tourDatesWidget.html`, which is the document the iframe
 * loads — the site does not talk to their API directly any more.
 */

/** Bandsintown's id for RIVER (SWE). Also set in tourDatesWidget.html. */
export const BANDSINTOWN_ARTIST = "id_15525238";

/** The artist page behind the "Follow me" button. */
export const BANDSINTOWN_URL = "https://www.bandsintown.com/a/15525238?noindex=1";
